/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_PendingInputs */

const en_admin_external_booking_edit_pending = /** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_admin_external_booking_edit_pending = /** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

const es_admin_external_booking_edit_pending = /** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente`)
};

const fr_admin_external_booking_edit_pending = /** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente`)
};

const nl_admin_external_booking_edit_pending = /** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In afwachting`)
};

/** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */
const it_admin_external_booking_edit_pending = en_admin_external_booking_edit_pending;

/** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_pending = en_admin_external_booking_edit_pending;

/** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */
const pl_admin_external_booking_edit_pending = en_admin_external_booking_edit_pending;

/** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */
const hu_admin_external_booking_edit_pending = en_admin_external_booking_edit_pending;

/** @type {(inputs: Admin_External_Booking_Edit_PendingInputs) => LocalizedString} */
const ro_admin_external_booking_edit_pending = en_admin_external_booking_edit_pending;

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Admin_External_Booking_Edit_PendingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_pending = /** @type {((inputs?: Admin_External_Booking_Edit_PendingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_PendingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_pending(inputs)
	if (locale === "de") return de_admin_external_booking_edit_pending(inputs)
	if (locale === "es") return es_admin_external_booking_edit_pending(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_pending(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_pending(inputs)
	if (locale === "it") return it_admin_external_booking_edit_pending(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_pending(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_pending(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_pending(inputs)
	return ro_admin_external_booking_edit_pending(inputs)
});
export { admin_external_booking_edit_pending as "admin.external_booking_edit.pending" }